import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { ErrorBoundary } from "@datadog/browser-rum-react";
import NotFoundPage from "./components/templates/NotFoundPage";

const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || "";
const DATADOG_APPLICATION_ID =
  import.meta.env.VITE_DATADOG_APPLICCATION_ID || "";
const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN || "";

datadogRum.init({
  applicationId: DATADOG_APPLICATION_ID,
  clientToken: DATADOG_CLIENT_TOKEN,
  site: "datadoghq.eu",
  service: "Fg.Mainframe",
  env: ENVIRONMENT,
  // Specify a version number to identify the deployed version of your application in Datadog
  version: import.meta.env.VITE_APP_VERSION || "1.0.0",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: "mask-user-input",
  plugins: [reactPlugin({ router: true })],
  allowedTracingUrls: ["https://snt.fg.se"],
  trackUserInteractions: true,
});

function ErrorFallback() {
  return <NotFoundPage />;
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary fallback={ErrorFallback}>
        <AppRoutes />
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
